import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/lems-v1/images/chat-project-6.png'


const _hoisted_1 = {
  class: "lmd-chat-section",
  id: "lmdchat"
}
const _hoisted_2 = { class: "clearfix" }
const _hoisted_3 = {
  id: "chatleft",
  class: "lmd-sm-2"
}
const _hoisted_4 = { class: "lmdchat-project-list" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  class: "loading-state"
}
const _hoisted_7 = {
  key: 1,
  class: "error-state"
}
const _hoisted_8 = { style: {"color":"red"} }
const _hoisted_9 = {
  key: 2,
  class: "chatlmd-pro-list conversations-scroll"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "conversation-date" }
const _hoisted_13 = {
  key: 1,
  class: "no-conversations"
}
const _hoisted_14 = {
  id: "closeProject",
  class: "close-row hide-desktop"
}
const _hoisted_15 = { class: "lmd-sm-7" }
const _hoisted_16 = { class: "lmd-chat-mdtop clearfix" }
const _hoisted_17 = { class: "lmd-chat-mdtop-l" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = {
  key: 2,
  class: "error-messages"
}
const _hoisted_22 = { style: {"color":"red"} }
const _hoisted_23 = { class: "chat-hide-desktop" }
const _hoisted_24 = { class: "pro-onlinelist-show" }
const _hoisted_25 = { class: "show-user-icon" }
const _hoisted_26 = { id: "showProject" }
const _hoisted_27 = { class: "lmd-chat-mdbtm" }
const _hoisted_28 = {
  key: 0,
  class: "chat-txt-box"
}
const _hoisted_29 = {
  key: 0,
  class: "no-messages"
}
const _hoisted_30 = { class: "chat-box-mid" }
const _hoisted_31 = { class: "right-chat-txt" }
const _hoisted_32 = ["textContent"]
const _hoisted_33 = { class: "chat-det" }
const _hoisted_34 = { class: "chat-date" }
const _hoisted_35 = { class: "chat-user-name" }
const _hoisted_36 = {
  key: 1,
  class: "system-message"
}
const _hoisted_37 = { class: "system-message-content" }
const _hoisted_38 = ["textContent"]
const _hoisted_39 = {
  key: 0,
  class: "loading-messages"
}
const _hoisted_40 = {
  key: 1,
  class: "no-conversation-selected"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h3", null, [
            _cache[3] || (_cache[3] = _createTextVNode(" Nextcloud Conversations ", -1)),
            (_ctx.conversations.length > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, "(" + _toDisplayString(_ctx.conversations.length) + ")", 1))
              : _createCommentVNode("", true)
          ]),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[4] || (_cache[4] = [
                _createElementVNode("p", null, "Loading conversations...", -1)
              ]))]))
            : _createCommentVNode("", true),
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.error), 1),
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.loadConversations && _ctx.loadConversations(...args))),
                  class: "retry-btn"
                }, "Retry")
              ]))
            : _createCommentVNode("", true),
          (!_ctx.loading && !_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (_ctx.conversations.length > 0)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_10, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedConversations, (conversation) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: conversation.id
                        }, [
                          _createElementVNode("a", {
                            href: "#",
                            class: _normalizeClass({ active: _ctx.selectedConversation?.id === conversation.id }),
                            onClick: ($event: any) => (_ctx.selectConversation(conversation))
                          }, [
                            _cache[5] || (_cache[5] = _createElementVNode("i", null, [
                              _createElementVNode("img", {
                                src: _imports_0,
                                alt: "Conversation Image"
                              })
                            ], -1)),
                            _createElementVNode("strong", null, [
                              _createTextVNode(_toDisplayString(_ctx.getConversationDisplayName(conversation)) + " ", 1),
                              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.getLastMessagePreview(conversation)), 1)
                            ])
                          ], 10, _hoisted_11)
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_13, [...(_cache[6] || (_cache[6] = [
                      _createElementVNode("p", null, "No conversations found", -1)
                    ]))]))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("button", _hoisted_14, _toDisplayString(_ctx.constants.CLOSE_BUTTON), 1)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            (_ctx.selectedConversation)
              ? (_openBlock(), _createElementBlock("h2", _hoisted_18, [
                  _createTextVNode(_toDisplayString(_ctx.getConversationDisplayName(_ctx.selectedConversation)) + " ", 1),
                  (_ctx.messages.length > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.messages.length) + " messages ", 1))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("h2", _hoisted_20, " Select a conversation to start chatting ")),
            (_ctx.error && _ctx.selectedConversation)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.error), 1),
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadMessages(_ctx.selectedConversation.token, false))),
                    class: "retry-btn"
                  }, "Retry")
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("button", _hoisted_26, _toDisplayString(_ctx.constants.SELECT_USER_BUTTON), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          (_ctx.selectedConversation)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                (!_ctx.loading && _ctx.sortedMessages.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [...(_cache[7] || (_cache[7] = [
                      _createElementVNode("p", null, "No messages in this conversation yet.", -1)
                    ]))]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  ref: "messagesContainer",
                  class: "messages-scroll",
                  onScroll: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onMessagesScroll && _ctx.onMessagesScroll(...args)))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedMessages, (message) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: message.id,
                      class: "message-container"
                    }, [
                      (!_ctx.isSystemMessage(message))
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(['chat-box', _ctx.isOwnMessage(message) ? 'chat-box-right' : 'chat-box-left'])
                          }, [
                            _createElementVNode("div", _hoisted_30, [
                              _createElementVNode("div", _hoisted_31, [
                                _createElementVNode("div", {
                                  class: "chat-txt-section preformatted",
                                  textContent: _toDisplayString(message.message)
                                }, null, 8, _hoisted_32)
                              ]),
                              _createElementVNode("div", _hoisted_33, [
                                _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.formatTimestamp(message.timestamp)), 1),
                                _createElementVNode("div", _hoisted_35, _toDisplayString(message.actorDisplayName), 1)
                              ])
                            ])
                          ], 2))
                        : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                            _createElementVNode("div", _hoisted_37, [
                              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "system-icon" }, "🔔", -1)),
                              _createElementVNode("span", {
                                class: "preformatted",
                                textContent: _toDisplayString(message.message)
                              }, null, 8, _hoisted_38),
                              _createElementVNode("small", null, _toDisplayString(_ctx.formatTimestamp(message.timestamp)), 1)
                            ])
                          ]))
                    ]))
                  }), 128)),
                  (_ctx.isLoadingMore)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [...(_cache[9] || (_cache[9] = [
                        _createElementVNode("p", null, "Loading older messages...", -1)
                      ]))]))
                    : _createCommentVNode("", true)
                ], 544)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_40, [...(_cache[10] || (_cache[10] = [
                _createElementVNode("p", null, "Please select a conversation from the left panel to start chatting.", -1)
              ]))]))
        ])
      ])
    ])
  ]))
}